export default {
  site_name: 'MARKJY',
  site_subtitle: '問號盒',
  site_tagline: 'UnknownBox',
  home: '首頁',
  blog: '部落格',
  contact: '聯絡方式',
  about: '關於',
  login: '登入',
  signout: '登出',
  logout: '註銷',
  register: '註冊',
  admin: '管理',
  theme_light: '明亮',
  theme_dark: '暗黑',
  language: '語言',
  username: '使用者名稱',
  password: '密碼',
  confirm_password: '確認密碼',
  old_password: '舊密碼',
  new_password: '新密碼',
  submit: '提交',
  cancel: '取消',
  save: '儲存',
  edit: '編輯',
  delete: '刪除',
  reply: '回覆',
  comment: '評論',
  comments: '則評論',
  no_comments: '暫無評論',
  write_comment: '寫下你的評論...',
  comment_placeholder: '輸入評論內容...',
  comment_username_placeholder: '臨時使用者名稱',
  comment_submit: '發表評論',
  comment_count: '則評論',
  reply_count: '則回覆',
  load_more: '載入更多',
  no_posts: '暫無文章',
  read_more: '閱讀全文',
  back_to_blog: '返回部落格',
  publish_date: '發布於',
  update_date: '更新於',
  about_me: '關於我',
  contact_me: '聯絡我',
  github: 'GitHub',
  email: '電子郵件',
  website: '網站',
  all_posts: '全部文章',
  new_post: '新增文章',
  edit_post: '編輯文章',
  post_title: '文章標題',
  post_content: '文章內容',
  manage_posts: '文章管理',
  manage_comments: '評論管理',
  change_password: '修改密碼',
  confirm_delete: '確認刪除？',
  login_success: '登入成功',
  register_success: '註冊成功',
  logout_confirm: '確認登出？',
  password_rule: '密碼6-24位',
  username_rule: '使用者名稱最少1漢字或2字母，最多14漢字',
  username_taken: '使用者名稱已被註冊',
  username_available: '使用者名稱可用',
  username_temp_taken: '此使用者名稱在當前內容下已被其他人使用',
  rate_limit: '評論頻率過高，請10分鐘後再試',
  not_found: '頁面不存在',
  server_error: '伺服器錯誤',
  network_error: '網路錯誤',
  login_required: '請先登入',
  admin_required: '需要管理員權限',
  confirm_logout: '確認登出使用者？此操作將清除登入狀態。',
  logout_with_password: '登出（需輸入密碼確認）',
  username_alphabetic_start: '使用者名稱不能以數字開頭',
  delete_account: '登出帳戶',
  delete_account_confirm: '此操作不可撤銷。請輸入密碼確認登出：',
  profile: '個人資料',
  contact_content: '如需聯絡我，請透過以下方式：',
  build_tool: '技術栈',
  delete_post_confirm: '確認刪除這篇文章？所有評論也將被刪除。',
  delete_comment_confirm: '確認刪除此評論？',
  image_upload: '上傳圖片',
  image_upload_fail: '圖片上傳失敗',
  copy_link: '複製連結',
  link_copied: '已複製到剪貼簿',
  expand: '展開',
  collapse: '收起',
  view_detail: '查看詳情',
  view_replies: '查看回覆',
  hide_replies: '隱藏回覆',
  write_reply: '寫下回覆...',
  lang_zh_CN: '简体中文',
  none: '無',
  lang_zh_TW: '繁體中文',
  lang_en: 'English',
}
